import template from './template.jst';
import './index.styl';
import { LeagueRowView } from '../../../../../../core/views/components';

export class CompJoinRowView extends LeagueRowView {
	get template() {
		return template;
	}

	initialize() {
		const { user, rounds } = this.options;

		this.model
			.set( {
				my_team: user.toJSON(),
				rounds: rounds.toJSON(),
				rounds_collection: rounds
			} )
			.checkAccessToLeague( user.id )
			.checkIsPossibleLeave()
			.setAvatar()
			.updateUserName()
			.isStarted()
			.checkAccessToSettings()
	}
}

export default CompJoinRowView;